<template>
  <div v-if="!loading" class="p-16 relative">
    <div class="max-w-5xl mx-auto space-y-16">
      <h3 class="text-indigo-500 capitalize">
        {{ $te('newOrder') ? $t('newOrder') : 'new order' }}
      </h3>

      <OrderForm
        :account-id="accountId"
        :supplier-options="supplierOptions"
        :action="doStoreClientOrder"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { clientAgenciesClient } from '@/api/clients';
import OrderForm from '@/components/Order/OrderForm.vue';

export default {
  name: 'ClientOrderCreate',
  components: {
    OrderForm,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      supplierOptions: [],
    };
  },
  async created() {
    try {
      const { data: { data = [] } = {} } = await clientAgenciesClient.list(this.accountId);

      this.supplierOptions = data.map((supplier) => ({
        label: supplier.account.name,
        value: supplier.account.id,
        accountRelationUuid: supplier.uuid,
      }));

      this.loading = false;
    } catch (error) {
      this.$router.back();
    }
  },
  methods: {
    ...mapActions('ui/accountOrders', ['storeClientOrder']),
    doStoreClientOrder(...args) {
      const payload = args[0] || {};

      const { accountId } = this;

      Object.assign(payload, { clientId: accountId });

      return this.storeClientOrder(payload)
        .then(() => {
          this.$router.replace({ name: 'accounts.orders', params: { accountId } });

          return Promise.resolve();
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
</script>
